const targetButtonId = 'tooltip-button-for-unpacking';
const targetTooltipId = 'tooltip-for-unpacking';
const targetTooltipLinkId = 'link-in-tooltip';

window.addEventListener('DOMContentLoaded', () => {
  const button = document.getElementById(targetButtonId);
  const tooltip = document.getElementById(targetTooltipId);
  const linkInTooltip = document.getElementById(targetTooltipLinkId);
  console.log(button)
  console.log(tooltip)
  console.log(linkInTooltip)
  if (!button || !tooltip || !linkInTooltip) {
    return;
  }

  button.addEventListener('click', () => {
    tooltip.setAttribute('aria-hidden', 'false');
  });
  button.addEventListener('mouseover', () => {
    tooltip.setAttribute('aria-hidden', 'false');
  });

  button.addEventListener('mouseout', (event) => {
    if (!event.relatedTarget || (event.relatedTarget.id !== targetTooltipId &&event.relatedTarget.id !== targetTooltipLinkId)) {
      tooltip.setAttribute('aria-hidden', 'true');
    }
  });
  tooltip.addEventListener('mouseout', (event) => {
    if (!event.relatedTarget || (event.relatedTarget.id !== targetButtonId && event.relatedTarget.id !== targetTooltipLinkId )) {
      tooltip.setAttribute('aria-hidden', 'true');
    }
  });
  tooltip.addEventListener('focusout', (event) => {
    if (!event.relatedTarget || (event.relatedTarget.id !== targetButtonId && event.relatedTarget.id !== targetTooltipLinkId )) {
      tooltip.setAttribute('aria-hidden', 'true');
    }
  });

  linkInTooltip.addEventListener('click', () => {
    tooltip.setAttribute('aria-hidden', 'true');
  });
});
